import {
  Component,
  OnInit,
  Injectable,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { CalendarEvent, CalendarUtils, CalendarDateFormatter } from 'angular-calendar';
import { GetMonthViewArgs, MonthView } from 'calendar-utils';
import { addWeeks } from 'date-fns';
import { CustomDateFormatter } from '../layout-control-calendar/custom-date-formatter.provider';
import { Constants } from 'src/app/constants/constants';
import * as moment from 'moment';

@Injectable()
export class MonthCalendarUtils extends CalendarUtils {
  getMonthView(args: GetMonthViewArgs): MonthView {
    args.viewStart = args.viewDate;
    args.viewEnd = addWeeks(args.viewDate, 3);
    return super.getMonthView(args);
  }
}

@Component({
  selector: 'transflo-calendar-month',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './calendar-month.component.html',
  providers: [
    {
      provide: CalendarUtils,
      useClass: MonthCalendarUtils
    },
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ]
})
export class CalendarMonthComponent implements OnInit {

  @Input() viewDate: Date;
  @Input() selectedDate: Date;
  @Input() events: CalendarEvent[];
  @Output() incrementDate = new EventEmitter();
  @Output() decrementDate = new EventEmitter();
  @Output() dayClicked = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onSwipeLeft($event: any): void {
    this.incrementDate.emit(Constants.month);
  }

  onSwipeRight($event: any): void {
    this.decrementDate.emit(Constants.month);
  }

  eventClicked(element: any): void {
    this.selectedDate = element.day.date;
    this.dayClicked.emit(element.day.date);
  }

  public isSelected(day): boolean {

    return moment(day).format('YYYY-MM-DD') === moment(this.selectedDate).format('YYYY-MM-DD')
  }

}
